export default {"src":"/_next/static/media/searchTrash.e7289620.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};